import React from 'react';
import { Routes, Route, Link } from 'react-router-dom'; // Import necessary components for routing
import { signOut } from 'firebase/auth';
import { auth } from '../firebase';
import Sidebar from './Sidebar';
import MobileNav from './MobileNav';
import '../App.css';
import NotAdmin from './NotAdmin';
import AllUsers from './users/AllUsers';
import ActivatedUsers from './users/ActivatedUsers';
import DeactivatedUsers from './users/DeactivatedUsers';
import AdminUsers from './users/AdminUsers';
import RegularUsers from './users/RegularUsers';
import AddTransaction from './users/AddTransaction';
import UserInfo from './users/UserInfo';
import TransactionLog from './users/TransactionLog';

const GetAdmin = ({ user, setUser }) => {
  // Function to handle user logout
  const handleLogout = () => {
    signOut(auth)
      .then(() => {
        setUser(null); // Clear user state on successful logout
      })
      .catch((error) => {
        console.error('Error logging out: ', error); // Log any errors
      });
  };

  // Determine if the user is an admin
  const isAdmin = user && user.role === 'admin';


  return (
    <div className='app'>
      {/* Sidebar visible only on larger screens */}
      <div className='hidden-desktop'>
        <Sidebar user={user} setUser={setUser} />
      </div>


      <div className="admin-content">
        {isAdmin ? (
          <>
                          
                  {/* Welcome message and logout button */}
                  {user && user.username && <h3>Logged in as {user.username} (<Link onClick={handleLogout} className='links'>Logout</Link>)</h3>}
                  {/* <button onClick={handleLogout} className='button'>Logout</button> */}

                  {/* Mobile sidebar component */}
                  <MobileNav />       


            {/* Define routes for different admin views */}
            <Routes>
              <Route index element={<AllUsers />} /> {/* Default route */}
              <Route path="all-users" element={<AllUsers />} />
              <Route path="admin-users" element={<AdminUsers />} />
              <Route path="regular-users" element={<RegularUsers />} />
              <Route path="activated-users" element={<ActivatedUsers />} />
              <Route path="deactivated-users" element={<DeactivatedUsers />} />
              <Route path="add-transaction" element={<AddTransaction />} />
              <Route path="/user/:userId/transactions" element={<TransactionLog />} />
              <Route path="user/:userId" element={<UserInfo />} /> {/* Route for user details */}

            </Routes>

          </>
        ) : (
          // Render NotAdmin component if the user is not an admin
          <NotAdmin user={user} setUser={setUser} />
        )}
      </div>
    </div>
  );
};

export default GetAdmin;
